customElements.component = 'faq-section';

if (!customElements.get(customElements.component)) {
  class FaqSection extends HTMLElement {
    constructor() {
      super();

      this.selectors = {
        dropdownHandler: '.js-toggle-dropdown',
        description: '.faq-section__item-description',

        active: 'faq-section__item--active'
      };

      this.dropdownHandlers = this.querySelectorAll(this.selectors.dropdownHandler);
    }

    toggleDropdown(e) {
      const target = e.currentTarget;
      const description = target.querySelector(this.selectors.description);

      target.classList.toggle(this.selectors.active);

      if (target.classList.contains(this.selectors.active)) {
        description.style.height = `${description.scrollHeight}px`;
      } else {
        description.style.height = '0';
      }
    }

    addEventListeners() {
      this.dropdownHandlers.forEach(handler => {
        handler.addEventListener('click', this.toggleDropdown.bind(this));
      });
    }

    removeEventListeners() {
      this.dropdownHandlers.forEach(handler => {
        handler.removeEventListener('click', this.toggleDropdown.bind(this));
      });
    }

    connectedCallback() {
      this.addEventListeners();
    }

    disconnectedCallback() {
      this.removeEventListeners();
    }
  }

  customElements.define(customElements.component, FaqSection);
}
